module.exports = __webpack_public_path__ + "h5/img/dh31.c1c8df1f.png";